import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
export const updateStageNameAgentRecruitment = createAsyncThunk(
  "login/updateStageNameAgentRecruitment",
  async (data, thunkAPI) => {
    try {
      const resp = await axios.put(
        `${process.env.REACT_APP_BASE_URL}api/recruitment/${data?.agentRecruitmentId}`,
        { stage: data?.stage },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return resp.data;
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(error.response.data.message);
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);
